import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function JobCard({ job }) {
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();

    // View Details click handler (সঠিক রাউট '/careers/' দেওয়া হয়েছে)
    const handleViewDetails = () => {
        navigate(`/career/${job.code}`);
    };

    // ট্যাগগুলো স্ট্রিং বা অ্যারে যাই হোক না কেন সেফলি হ্যান্ডেল করার জন্য
    const renderTags = () => {
        if (!job.tags) return null;
        let tagsArray = [];
        if (Array.isArray(job.tags)) {
            tagsArray = job.tags;
        } else if (typeof job.tags === 'string') {
            tagsArray = job.tags.split(',');
        }

        return tagsArray.map((tag, idx) => (
            <span key={idx} className="badge bg-success bg-opacity-10 text-success fw-normal px-2 py-1" style={{ fontSize: '11px' }}>
                ✓ {tag.trim()}
            </span>
        ));
    };

    return (
        <div
            className="card mb-3 p-3 transition-all"
            style={{
                transform: isHovered ? 'scale(1.01)' : 'scale(1)',
                transition: 'transform 0.25s ease-in-out, box-shadow 0.25s ease-in-out, border-color 0.25s ease-in-out',
                boxShadow: isHovered ? '0 0.5rem 1rem rgba(13, 110, 253, 0.15)' : '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)',
                border: isHovered ? '1px solid rgba(13, 110, 253, 0.5)' : '1px solid #dee2e6'
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className="card-body p-0">
                {/* Top Badges & Salary */}
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                        <span className="badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 px-2 py-1" style={{ fontSize: '11px' }}>
                            {job.country?.name}
                        </span>
                        <span className="badge bg-warning bg-opacity-10 text-warning text-dark border border-warning border-opacity-25 px-2 py-1" style={{ fontSize: '11px' }}>
                            {job.category?.name}
                        </span>
                        <span className="text-muted" style={{ fontSize: '12px' }}>#Code: {job.code}</span>
                    </div>
                    <span className="badge bg-success bg-opacity-10 text-success fw-bold px-2 py-1" style={{ fontSize: '13px' }}>
                        {job.salary}
                    </span>
                </div>

                {/* Job Title & Location */}
                <h5 className="fw-bold text-dark mb-1" style={{ fontSize: '16px' }}>{job.title}</h5>
                <p className="text-muted mb-2" style={{ fontSize: '12px' }}>
                    Contract: <span className="text-dark fw-semibold">{job.contract}</span> • {job.location || job.region}
                </p>

                {/* Description */}
                <p className="text-secondary mb-3" style={{ fontSize: '12px', lineHeight: '1.5' }}>
                    {job.short_description || job.description}
                </p>

                {/* Perks / Tags */}
                <div className="d-flex flex-wrap gap-1.5 mb-3">
                    {renderTags()}
                </div>
            </div>

            {/* Footer of Card */}
            <div className="d-flex justify-content-between align-items-center pt-3 border-top mt-2" style={{ fontSize: '12px' }}>
                <span className="text-muted">Deadline: <strong className="text-dark">{job.deadline}</strong></span>
                <div className="d-flex gap-2">
                    <button
                        onClick={handleViewDetails}
                        className="btn btn-outline-primary btn-sm px-3 fw-semibold"
                        style={{ fontSize: '12px' }}
                    >
                        View Details
                    </button>
                    <button
                        onClick={handleViewDetails}
                        className="btn btn-success btn-sm px-3 fw-semibold"
                        style={{ fontSize: '12px' }}
                    >
                        Apply Now
                    </button>
                </div>
            </div>
        </div>
    );
}